import React 		from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx';
import ReactionBar from './_ReactionBar.jsx';
import {CustomConfirm} 	from './_Utilities.jsx';
import VideoContent from './_VideoContent.jsx';



export default class StoryCard extends BLComponent {

	constructor(props, context) {
		super(props, context);

		this.state = {
			reactions : null,
			myVote: null
		}

		this.yearsFull = [
				"0-5 years"
			, "6-10 years"
			, "11-15 years"
			, "16-20 years"
		]
	}

	componentDidMount()
	{
		this.getReactions();
		const allLinks = this.storyCard ? this.storyCard.querySelectorAll('.js-story-main a') : null;

		if(allLinks && allLinks.length) {
			for(let i = 0; i < allLinks.length; i++) {
				allLinks[i].addEventListener('click', (e) => this.handleLink(e, allLinks[i].href));
			}
		}
	}

	render() {
		const {story, classes = ''} = this.props;
		const storyPrompt = this.getStoryPrompt(story.nWeek);

		return (
			story.dmUser ?
			<div key={story.id} ref={storyCard => this.storyCard = storyCard} className={"story-card " + classes}>
				<article className="story-card__internal">
					<header className="story-card__header">
						<h1 className="story-card__title">{story.strStoryTitle}</h1>
						{this.renderProfile()}
					</header>
					<main className="story-card__main">
						{this.renderFeatured()}
						
						<div className="base-formating js-story-main" dangerouslySetInnerHTML={{__html: story.strStoryText}}/>
					</main>
					<footer className="story-card__footer">
						<ReactionBar reactions={this.state.reactions} myVote={this.state.myVote} recordResponse={(response,cb) => this.recordResponse(response,cb)}/>
						{this.props.showPrompt ? 
							<div className="story-card__prompt">
								Writing prompt:<span className="pill pill--medium-blue pill--round-square story-card__prompt-pill">{storyPrompt}</span>
							</div>
						:
							this.props.showViewAll != false && <a href={blapp.url2.getAnniversaryStoriesUrl(story.nWeek+1)} className="story-card__footer-link" target="_blank">View all stories</a>
						}
					</footer>
				</article>
			</div>
			:
			null
		);
	}

	renderFeatured() {
		const {story} = this.props;
		const file = story.dmFile;
		const isFileImage = file && (file.strExtension.toLowerCase() == 'jpg' || file.strExtension.toLowerCase() == 'jpeg' || file.strExtension.toLowerCase() == 'png' || file.strExtension.toLowerCase() == 'gif')
		const isFileVideo = file && (file.strExtension.toLowerCase() == 'mov' || file.strExtension.toLowerCase() == 'mp4')
		const isLinkVideo = story.strUrlMedia && (story.strUrlMedia.toLowerCase().includes('youtube') || story.strUrlMedia.toLowerCase().includes('youtu.be') || story.strUrlMedia.toLowerCase().includes('vimeo'))
		const isLinkImage = story.strUrlMedia && this.isUriImage(story.strUrlMedia);
		const isLinkUndef = story.strUrlMedia && !isLinkVideo && !isLinkImage;
	
		if(isFileImage) {
			return (
				<figure className="story-card__figure">
					<div className="story-card__main-image">
						<div className="story-card__main-image-internal">
							<img className="story-card__main-image-item" src={file.url}/>
						</div>
					</div>
					{story.strCaption ? <figcaption className="l-block text--note l-margin-top text--center">{story.strCaption}</figcaption> : null}
				</figure>
			);
		}else if(isFileVideo) {
			return (
				<figure className="story-card__figure">
					<video width="320" height="240" controls>
						<source src={file.url} type="video/mp4"/>
						<source src={file.url} type="video/quicktime"/>
						The video can not be reproduced.
					</video>
					{story.strCaption ? <figcaption className="l-block text--note l-margin-top text--center">{story.strCaption}</figcaption> : null}
				</figure>
			);
		}else if(isLinkVideo) {
			return (
				<figure className="story-card__figure">
					{this.renderVideo(story.strUrlMedia)}
					{story.strCaption ? <figcaption className="l-block text--note l-margin-top text--center">{story.strCaption}</figcaption> : null}
				</figure>
			);
		}else if(isLinkUndef){
			return (
				<figure className="story-card__figure">
					<div className="story-card__main-link">
						<i className="fas fa-link l-margin-right"/>
						<a href={story.strUrlMedia} onClick={(e) => this.handleLink(e, story.strUrlMedia)} className="overflow-ellipsis">{story.strUrlMedia}</a>
					</div>
					{story.strCaption ? <figcaption className="l-block text--note l-margin-top text--center">{story.strCaption}</figcaption> : null}
				</figure>
			);
		}
	}

	handleLink(e, link) {
		if(link.includes('bricklink.com')) {
			return;
		}

		if(document.querySelector('.custom-confirm')) {
			return;
		}

		e.preventDefault();

		const confirmContent = '<h2 class="page-title l-margin-bottom">You are about to leave BrickLink</h2><p>Are you sure you want to continue?</p>';

		CustomConfirm( 
			confirmContent
		, 	{ 
				false:	`No, I want to stay on BrickLink`
			,	true:	'Yes, take me away' 
			} 
		).then(
			( value ) => 
			{
				if( value == true ) 
				{
					window.open(link, '_blank');
				}
			}	
		);
	}

	renderProfile() {
		let {story} = this.props;
		let user = story.dmUser;
		let showUsername = story.bShowUsername;
		const {nFeedbackScore, skUsername} = user;

		let me = blapp.session.getMe();
		
		var feedbackIconUrl	= null;

		if(nFeedbackScore != null) {
			feedbackIconUrl	= blapp.url2.getFeedbackIconUrl(nFeedbackScore);
		}else if ( feedbackRank != '' ) {
			feedbackIconUrl	= blapp.url2.getFeedbackIconUrlByLevel(parseInt(feedbackRank));
		}

		return (
			<article className={"simple-profile-card story-card__header-profile"}>
				<div className="simple-profile-card__image simple-profile-card__image--medium" style={{backgroundImage: `url(${blapp.url2.getProfileImgUrl(user,'large')})`}}>
					<img className="simple-profile-card__image-item" src={blapp.url2.getProfileImgUrl(user,'large')} onError={(e) => e.target.src =blapp.session.getMyProfileURL('medium')}/>
				</div>
				<div className="simple-profile-card__details">
					{showUsername ? 
						<div className="store-detail-lockup">
							<a href={blapp.url.getUserFeedbackURL(skUsername)} target="_blank" className="store-detail-lockup__name" title={skUsername}>{skUsername}</a> 
							{feedbackIconUrl ? <img className="store-detail-lockup__feedback-brick" src={feedbackIconUrl}/> : null}
						</div>
					: 
						null
					}
					<p>BrickLink user of {this.yearsFull[story.nUserFromTime]}</p>
				</div>
			</article>
		);
	}

	renderVideo(url) {
		return <VideoContent url={url}/>;
	}

	isUriImage(uri)
	{
		uri = uri.split('?')[0];
		var parts = uri.split('.');
		var extension = parts[parts.length-1];
		var imageTypes = ['jpg','jpeg','tiff','png','gif','bmp','svg'];
		if(imageTypes.indexOf(extension) !== -1) {
			return true;   
		}
		return false;
	}

	getReactions()
	{
		blapp.bl20YearPosts.fetchReactions( 
			this.props.story.idSubmission
		,	2
		,	( data ) =>
			{
				if ( data )
				{
					let reactions = {
						heart: data.nR1Count
					,	thumbsUp: data.nR2Count	
					,	eyes: data.nR3Count	
					,	joy: data.nR4Count		
					,	tada: data.nR5Count
					}
					this.setState( { reactions: reactions, myVote: data.nUserReaction } );
				}
			}
		);	
	}

	getStoryPrompt(id)
	{
		switch(id)
		{
			case 0:
				return 'Coming across BrickLink';
			case 1:
				return 'Finding friendship';
			case 2:
				return 'Buyer/seller story';
			case 3:
				return 'Hopes for future BrickLink';
			case 4:
				return '#SameMold';
		}
	}


	recordResponse(response, cb) {
		let prevResponse = this.state.myVote;
		blapp.models.fetch(
			"_submit_story_reaction"
			, {
				controller: "anni.BLCAnniversary"
				, method: "submitStoryReaction"
				, params: [this.props.story.idSubmission, response]
				, refresh: true
			}
		).then(
			(data) => {
				if (data != null) {
					let reactions = {
						heart: data.nR1Count
					,	thumbsUp: data.nR2Count	
					,	eyes: data.nR3Count	
					,	joy: data.nR4Count		
					,	tada: data.nR5Count
					}
					this.setState({reactions: reactions, myVote: response == prevResponse ? 0 : response})
				}
			}
		).catch(
			(err) => {
				console.log(err)
			}
		).finally(
			() =>{if(cb) cb()}
		);
	}
};